import React from "react";
import "../css/homepage.css";
// import ContentPage from "./content-page"
// import Meta from "./meta"
// import Wrapper from "./wrapper"
// import { Button } from "react-bootstrap"
import Link from "gatsby-link";
import PropTypes from "prop-types";
import Heading from "../components/Heading";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
// import VideoComponent from "../components/VideoComponent"
import Slider from "react-slick";
import MediaQuery from "react-responsive";
import "../components/slick.css";
import "../components/slick-theme.css";

let settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  // slidesToShow: slidesToShow,
};

const BG1 = "https://bawaindustries.com/assets/images/Bawa-Website-Hero_Option2.jpg";
const CD = "https://bawaindustries.com/assets/images/BI_hero_image_coupon_3.png";
const CD1 = "https://bawaindustries.com/assets/images/BI_hero image_coupon_Phone.png";
const WS = "https://bawaindustries.com/assets/images/Whole-Masalas.png";
const BM = "https://bawaindustries.com/assets/images/Blended-Masalas.png";
const PM = "https://bawaindustries.com/assets/images/Puja-Materials.png";
const SI = "https://bawaindustries.com/assets/images/Speciality-Ingredients.png";
const L1 = "https://bawamasalacompany.com/assets/images/amazonlogo.png";
// const V1 = "https://bawaindustries.com/assets/videos/BAWA_MASALA_20_SEC.mp4"

const productRanges = [
  {
    title: "Whole / Powdered Masalas",
    identifier: "whole_masalas",
    imgSrc: WS,
  },
  {
    title: "Blended Masalas",
    identifier: "blended_masalas",
    imgSrc: BM,
  },
  {
    title: "Puja Materials",
    identifier: "puja_materials",
    imgSrc: PM,
  },
  {
    title: "Speciality Ingredients",
    identifier: "speciality_ingredients",
    imgSrc: SI,
  },
];

const HomeView = ({ location }) => (
  <div className="global__wrapper" style={{ position: "relative" }} id="error">
    <div className="home__wrapper">
      <div className="home__copy__slider">
        <MediaQuery query="(min-width: 769px)">
          <img src="https://bawaindustries.com/assets/hero/BI-Hero-Image-1440x600.jpg" alt="" width="100%" />
        </MediaQuery>

        <MediaQuery query="(max-width: 768px)">
          <img src="https://bawaindustries.com/assets/hero/BI-Hero-Image-800X1200.jpg" alt="" width="100%" />
        </MediaQuery>
        <span className="tvc__cta">
          <a href="#video__section">Watch TVC</a>
        </span>
        <div className="down_strip" />
      </div>

      <div className="home__copy">
        <div className="row text-center">
          <div className="col-md-12">
            <Heading title={"Product Range"} />
            <br />
            <br />
          </div>
          {/* <div className="product__buy">
            <div className="P_subtext">
              Now Available
              <br /> on
            </div>
            <div className="content row">
              <div className="col-md-12">
                <a href="https://www.amazon.in/s?me=A3K8OWGYS3AILJ&marketplaceID=A21TJRUUN4KGV" target="_blank">
                  <img src={L1} alt="amazon logo" width="300px" className="img img-responsive" />
                </a>
              </div>
            </div>
          </div> */}
          <MediaQuery query="(min-width:992px)">
            <div className="row products">
              {productRanges.map((item, i) => {
                return (
                  <div className="col-md-6" key={i}>
                    <ScrollAnimation key={i} delay={0} duration={2} animateIn="zoomIn" offset={250}>
                      <div className="product__image">
                        <Link to={`store?${item.identifier}`}>
                          <img src={item.imgSrc} alt={item.title} className="img img-responsive center-block" />
                        </Link>
                      </div>
                      <div className="product__name">
                        <Link to={`store?${item.identifier}`}>{item.title}</Link>
                      </div>
                    </ScrollAnimation>
                  </div>
                );
              })}
            </div>
          </MediaQuery>
          <MediaQuery query="(max-width:992px)">
            <div className="row products">
              <Slider {...settings}>
                {productRanges.map((item, i) => {
                  return (
                    <div className="" key={i}>
                      <ScrollAnimation delay={0} duration={2} animateIn="zoomIn" offset={250}>
                        <div className="product__image">
                          <Link to={`store?${item.identifier}`}>
                            <img src={item.imgSrc} alt={item.title} className="img img-responsive center-block" />
                          </Link>
                        </div>
                        <div className="product__name">
                          <Link to={`store?${item.identifier}`}>{item.title}</Link>
                        </div>
                      </ScrollAnimation>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </MediaQuery>
          <div className="row">
            <div id="video__section" className="video__section">
              <div className="col-md-12">
                <Heading title={"A Tradition of Excellence"} />
              </div>
              <div className="videos">
                <iframe
                  width="100%"
                  src="https://www.youtube.com/embed/iS1zg5xp3J0"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                {/* <VideoComponent src="https://bawaindustries.com/assets/videos/BAWA_MASALA_20_SEC.mp4" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="1" />
  </div>
);

HomeView.propTypes = {
  location: PropTypes.object,
};

export default HomeView;



// WEBPACK FOOTER //
// ./src/components/HomeView.js